// Parametrizar el nombre del chatbot
import * as firebase from 'firebase';

import Util from '../utils.js';

const database = firebase.firestore();

    async function GetNombreActual(){

        const nombreChatbot = [];

        // iZTLJAcQU547ZhEUtp2f //documento de prueba
        const queryRes = await database.collection("bots").doc("iZTLJAcQU547ZhEUtp2f").get();

            const data = queryRes.data();
            if(data)
                nombreChatbot.push(data.nombre);

        return nombreChatbot;
    }

    // validar que no exista otro bot con el mismo nombre
    async function ValidarNombreUnico(nombre){
        const querySnapshot = await database.collection("bots").where("nombreMin", "==", ""+nombre.toLowerCase().trim()+"").get();
        
        let nombreUnico = false;
        if(querySnapshot.docs.length)
            nombreUnico = true;

        return nombreUnico;
    }

    function PostNombreBot(nombre){
        const nuevoNombre = database.collection("bots").doc("iZTLJAcQU547ZhEUtp2f");

        let nombreReal = nombre.trim();
        let nombreMod = nombre.toLowerCase().trim();

        return nuevoNombre.update({
            nombre: nombreReal,
            nombreMin: nombreMod
        }).then(function() {
            console.log("Document successfully updated!");
        }).catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
        });
        
    }

    //GENERAR NOMBRES SUGERIDOS //

    function GenerarNombres(nombre){
        // VALIDAR QUE NO ME SUGIERA NOMBRES QUE YA ESTEN GUARDADOS EN LA BASE DE DATOS
        const nombresPosibles = ["Aarón","Aaronit","Aba","Abaco","Abalen","Abbas","Abbie","Abbott","Abby","Abdala","Abdas ","Abdecalas","Abdel","Abderico","Babeli","Babet","Babette","Babil","Babilas","Bachar","Baco","Badda","Basha","Basi","Basia","Basiana","Basiano","Basil","Basila","Basileo","Basilia",
        "Basiliano","Basilides","Basilio","Basilisa","Basilisco","Calagero","Calanit","Calamanda", "Calandia","Calandra","Calanico","Calanit","Calantha", "Caldeolo", "Calder", "Caleb", "Caledonia", "Caledonio","Calel", "Calen","Calepodio","Caley","Claudiano","Claudina","Claudine", "Claudino","Claudio", 
        "Claus","Clay","Clayton", "Cleantha", "Cleary", "Cleavon", "Clelia","Dámaris","Damasa","Damasia","Damaso","Dámaso","Damek","Damen","Damian","Damián","Damiana","Damiano","Damir","Damiro","Damocles","Damon","Dan","Dana","Danae","Danah","Danai","Danalí","Danas","Dándara","Dane","Danei","Danel","Ginebra",
        "Gines","Ginesa","Ginette","Ginger","Ginny","Gino","Grace","Gracia","Graciana","Graciano","Gracias","Gracie","Graciela","Graciliano","Gradiva","Grady","Graham","Grainne","Gram","Granger","Grania","Alul","Ham","Hamal","Haman","Hamilton","Hamlet","Hamlin","Hampartsum","Hamza","Hana","Hanae","Hanan",
        "Hania","Hank","Hanka","Hanna","Hannah","Isabis","Isacar","Isachar","Isacio","Isadora","Isael","Isaí","Isalenia","Isam","Isao","Isaul","Isaura","Isauro","Isberga","Isel","Isela","Iselda","Jacinda","Jacinta","Jacinthe","Jacinto","Jack","Jackie","Jackson","Jaclyn","Jaco","Jacob", "Jacoba","Jacobe","Jacobo",
        "Jacquelina","Jacqueline","Jacques","Karima","Karimah","Karin","Karina","Karine","Karis","Karl","Karla","Karli","Karma","Karol","Karolina","Karsten","Karumanta","Kasen","Kasi","Kasia","Loreto","Loretta","Loreyama","Lori","Loriana","Lorinda","Loris","Lorna","Lorne","Lorraine","Loruhama","Lorujama","Lot","Lotario",
        "Max","Maxelinda","Maxi","Maxim","Maxima","Maxime","Maximiana","Maximiano","Maximilian","Maximiliana","Maximiliano","Maximina","Maximiniana","Maximino","Patton","Patty","Patxi","Pau","Paul","Paula","Paule","Paulette","Paulin","Paulina","Pauline","Paulino","Paulo","Paulos","Pausidio"];
        
        const nombresSugeridos = nombresPosibles.filter(el=>el.toLowerCase().includes(nombre.toLowerCase().trim()));
        
        return nombresSugeridos; 
    }


export default {
    GetNombreActual,
    ValidarNombreUnico,
    PostNombreBot,
    GenerarNombres
}